/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {Spec as ɵc} from './lib/Spec/Spec';
export {BaseSpec as ɵb} from './lib/base/base-Spec';
export {DomSpec as ɵa} from './lib/base/dom-Spec';
export {RouteOptions as ɵd} from './lib/spec-routing/route-options';